import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';

@Component({
  selector: 'general-view',
  standalone: true,
  imports: [NgIf],
  templateUrl: './view.component.html',
  styleUrl: './view.component.css'
})
export class ViewComponent implements OnInit {
  id?: string;
  ref: string;
  item?: any;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.ref = this.route.snapshot.params['ref'];
  }

  ngOnInit(): void {
    console.log(this.ref, this.id)
    this.http.get(`/api/${this.ref}/${this.id}`)
    .pipe(first()).subscribe({
      next: item => this.item = item,
      error: e => console.log(e)
    })
  }

  get keys() { return Object.keys(this.item).filter(k => !k.startsWith('_') && k != 'displayName') }
}
